/* eslint-disable no-nested-ternary */
/* eslint-disable consistent-return */
/* eslint-disable array-callback-return */
/* eslint-disable react/no-array-index-key */
/* eslint-disable eqeqeq */
/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable no-param-reassign */
import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import * as queryString from 'query-string';
import { find, findIndex, debounce } from 'lodash';
import PropTypes from 'prop-types';

import ErrorPage from '../../components/ErrorPage';

import AdWrapper from '../../components/Ads/AdWrapper';
import GenericPopup from '../../components/PopUps/GenericPopup';
import LearnMoreUtrCollegePopUp from '../../components/Upgrade/UpgradeToUtrCollege/LearnMoreUtrCollegePopUp';
import PhotoEditor from '../../components/PhotoUpload/PhotoEditor';
import ProfileHeader from '../../components/Profile/Header/ProfileHeader';
import ProfileTabManager from '../../components/Profile/ProfileTabManager';
import TabBar from '../../components/TabBar';
import UpgradeToProClubPopUp from '../../components/Upgrade/UpgradeToProClubPopUp';
import head from '../../components/Meta';
import { CtaData } from '../../components/cards/CtaCard';
import { fetchMatchingProfilesById } from '../../actions/get-rated-actions';
import { getRatingDetails, setRatingChoice } from '../../utils';
import { setClaimedPlayerId } from '../../actions/onboarding-actions';
import { showErrorPopup } from '../../actions/notification-actions';
import { updateQueryParams } from '../../actions/search-actions';

import { AdTypes } from '../../utils/types';
import { collegeRecruitingPlayerAgeMin, collegeRecruitingPlayerAgeMax, collegeRecruitingOwnProfileStudentTabAgeMax, collegeProspectMaxAge, PlayerProfileTabIdentifiers } from '../../utils/constants';
import { isFreeCollegeClub, ClubTierTypes } from '../../utils/clubs';
import { userIsFreeCollegeClubOwner, userIsProCollegeClubOwner, userIsClubAdminOrOwner } from '../../utils/user';

import * as actions from '../../actions/profile-actions';
import * as loginPopUpActions from '../../actions/login-popup-actions';
import * as messagingActions from '../../actions/messaging-actions';
import * as savedListActions from '../../actions/saved-lists-actions';
import { PaidHitAvailabilityPopup } from '../../components/PopUps';
import { clearProfileTabData, getStatsData } from '../../actions/profile-tab-actions';
import { fetchUpgradePopup } from '../../actions/upgrade-to-power-actions';
import { getApiAxiosInstance } from '../../utils/network';
import { isLoginPopUpNeeded, userParams, titles } from '../../components/PopUps/LoginPopUpWrapper/LoginPopUp/utils';
import { requestPaidHitForPlayer } from '../../api/tmsEventsApi';
import { uploadTempPhoto, clearTempPhoto } from '../../actions/upload-actions';
import { getStandardErrorPageConfig } from '../../utils/errorPage';
import withStatsig from '../../components/hocs/withStatsig';
import withCPPDynamicConfig from '../../components/hocs/withCPPDynamicConfig';

import styles from './profilePage.scss';
import config from '../../../config';

const _ = { find, findIndex, debounce };

const { OVERVIEW, RESULTS, EVENTS, CLUBS, STATS, STUDENT_INFO } = PlayerProfileTabIdentifiers;

export function getTabVisibilityConfig(tabId, profileState) {
    const { isProgressionBallPlayer, showStudentInfoTab } = profileState;

    switch (tabId) {
        case OVERVIEW:
        case RESULTS:
        case EVENTS:
        case CLUBS:
            return { showTab: true, needsLogin: true };
        case STATS:
            return { showTab: !isProgressionBallPlayer, needsLogin: true };
        case STUDENT_INFO:
            return { showTab: showStudentInfoTab && !isProgressionBallPlayer, needsLogin: true };
        default:
            return null;
    }
}
class ProfilePage extends React.Component {
    constructor(props) {
        super(props);

        const studentInfoTab = {
            id: STUDENT_INFO,
            sortPosition: STUDENT_INFO,
            title: 'Student Info',
            needsLogin: true,
            showTab: false,
            showEditForm: false,
        };
        const isCppEnabled = !!props.cppConfig?.isCollegeProspectPowerEnabled;

        this.state = {
            showPhotoEditor: false,
            showUpgradeToProCollege: false,
            showProClubPopup: false,
            showPaidHitAvailabilityPopup: false,
            photoEditorType: 'player_profile',
            redirect: false,
            redirectUrl: '/',
            redirectSearch: '',
            redirectState: {},
            tabs: [
                {
                    id: OVERVIEW,
                    sortPosition: OVERVIEW,
                    title: 'Overview',
                    showTab: true,
                    needsLogin: true,
                    active: true,
                },
                {
                    id: STATS,
                    sortPosition: STATS,
                    title: 'Stats',
                    needsLogin: true,
                    showTab: true,
                },
                ...(isCppEnabled ? [studentInfoTab] : []),
                {
                    id: RESULTS,
                    sortPosition: RESULTS,
                    title: 'Results',
                    showTab: true,
                    needsLogin: true,
                },
                {
                    id: EVENTS,
                    sortPosition: EVENTS,
                    title: 'Events',
                    needsLogin: true,
                    showTab: true,
                },
                {
                    id: CLUBS,
                    sortPosition: CLUBS,
                    title: 'Clubs',
                    needsLogin: true,
                    showTab: true,
                },
                ...(isCppEnabled ? [] : [studentInfoTab]),
            ],
            actionPerformed: false,
            showIsProMessagePopup: false,
            showUnclaimedProfileMessagePopup: false,
            paidHitPopupMessage: '',
            showPaidHitPopupMessage: false,
            isSendingPaidHitRequest: false,
            isPlayerSavedToList: false,
        };
        this.setPlayerId = debounce(this.setPlayerId.bind(this), 100);
        this.handleTabClick = this.handleTabClick.bind(this);
        this.handleCropPhoto = this.handleCropPhoto.bind(this);
        this.handleCropBannerPhoto = this.handleCropBannerPhoto.bind(this);
        this.handleHidePhotoEditor = this.handleHidePhotoEditor.bind(this);
        this.handleUploadPhotoPhotoStart = this.handleUploadPhotoPhotoStart.bind(this);
        this.handleUploadPhotoBannerStart = this.handleUploadPhotoBannerStart.bind(this);
        this.handleUploadPhoto = this.handleUploadPhoto.bind(this);
        this.handlePhotoPopoverClick = this.handlePhotoPopoverClick.bind(this);
        this.setBannerRef = this.setBannerRef.bind(this);
        this.updateBanner = this.updateBanner.bind(this);
        this.photoInputRef = React.createRef();
        this.menuSelected = this.menuSelected.bind(this);
        this.sendMessage = this.sendMessage.bind(this);
        this.handleShowLoginPopUp = this.handleShowLoginPopUp.bind(this);
        this.setIsProMessagePopupFlg = this.setIsProMessagePopupFlg.bind(this);
        this.setUnclaimedProfileMessagePopup = this.setUnclaimedProfileMessagePopup.bind(this);
        this.showEditForm = this.showEditForm.bind(this);
        this.checkIfTabCanSwitch = this.checkIfTabCanSwitch.bind(this);
        this.showUpgradeToProCollege = this.showUpgradeToProCollege.bind(this);
        this.getFreeCollegeClubIdOptionsUpgrade = this.getFreeCollegeClubIdOptionsUpgrade.bind(this);
        this.handleOnRequestPaidHit = this.handleOnRequestPaidHit.bind(this);
        this.showPaidHitMessage = this.showPaidHitMessage.bind(this);
        this.handleOnRequestClosePaidHitPopup = this.handleOnRequestClosePaidHitPopup.bind(this);
        this.handleOnViewPaidHitsClicked = this.handleOnViewPaidHitsClicked.bind(this);
        this.handleRequestPaidHitSubmit = this.handleRequestPaidHitSubmit.bind(this);
        this.handleRemoveProfilePhoto = this.handleRemoveProfilePhoto.bind(this);
    }

    componentDidMount() {
        this.setPlayerId(this.props?.match?.params?.playerId);
        const hasPtsRankings = this.props?.profile?.ptsRankings && Object.keys(this.props?.profile?.ptsRankings).length > 0;
        if (!hasPtsRankings) {
            this.props.getPtsPlayerRankings(this.props?.match?.params?.playerId);
        }
        this.handleShowLoginPopUp();
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.error === 'unauthorized') {
            window.location.reload();
            return;
        }

        const profileState = this.calculateProfileState(nextProps);
        const playerIdChanged = nextProps.match.params.playerId !== this.props.profile.playerId;
        const newLogin = this.props.auth?.user !== nextProps.auth?.user;

        if (playerIdChanged || newLogin) {
            this.handlePlayerIdChange(nextProps);
        } else {
            this.handleProfileUpdate(nextProps, profileState);
        }

        this.handleSavedLists(nextProps, profileState.userIsPowered);
    }

    componentDidUpdate() {
        const parsed = queryString.parse(this.props.location.search);
        const { isProfileLoaded } = this.props.profile;
        if (parsed.showPopup && !this.state.actionPerformed && isProfileLoaded) {
            this.props.history.replace({
                state: null,
            });
            this.handleShowLoginPopUp(parsed.type);
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({
                actionPerformed: true,
            });
        }

        const { auth } = this.props;
        const userLoggedIn = !!auth?.user;
        const tabIdentifier = parseInt(parsed.t) || PlayerProfileTabIdentifiers.OVERVIEW;
        const currentActiveTab = _.find(this.state.tabs, { active: true });

        const profileStateForVisibility = isProfileLoaded ? this.calculateProfileState(this.props) : null;
        const tabConfigForPath = profileStateForVisibility
            ? getTabVisibilityConfig(tabIdentifier, profileStateForVisibility)
            : null;
        const tabIsVisible = tabConfigForPath ? tabConfigForPath.showTab : false;

        if (isProfileLoaded && (!userLoggedIn || !tabIsVisible) && tabIdentifier !== OVERVIEW) {
            this.props.history.push({
                search: `?t=${OVERVIEW}`,
            });
        }

        if (currentActiveTab?.id !== tabIdentifier) {
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState((prevState) => {
                const tabs = prevState.tabs.map((tab) => (tab.id === tabIdentifier ? { ...tab, active: true } : { ...tab, active: false }));
                return { tabs };
            });
        }
    }

    setIsProMessagePopupFlg(value) {
        this.setState({ showIsProMessagePopup: value });
    }

    setUnclaimedProfileMessagePopup(value) {
        this.setState({ showUnclaimedProfileMessagePopup: value });
    }

    setPlayerId(playerId) {
        this.props.setPlayerId(playerId);
    }

    setBannerRef(img) {
        this.banner = img;
        if (this.banner) {
            if (img.complete && img.naturalHeight !== 0) {
                this.updateBanner();
            }
            this.banner.addEventListener('load', this.updateBanner);
        }
    }

    getFreeCollegeClubIdOptionsUpgrade() {
        const { user } = this.props.auth;

        const clubOwnerAdminFreeCollegeClubs = user.clubMemberships.filter((clubMembership) => {
            return isFreeCollegeClub(clubMembership.tierTypeName) && userIsClubAdminOrOwner(clubMembership);
        });

        if (clubOwnerAdminFreeCollegeClubs.length > 0) {
            return clubOwnerAdminFreeCollegeClubs.map((clubMembership) => {
                return {
                    value: clubMembership.clubId,
                    label: clubMembership.name,
                };
            });
        }
        return null;
    }

    getRenderData() {
        const { tabs, isOwnProfile } = this.state;
        const { profile, auth, search, showAds, playerProfileConfig, isMobileWidth } = this.props;
        const parsedQuery = queryString.parse(this.props.location.search);
        const statsView = parsedQuery.view || null;
        const { claimedPlayer } = auth?.user || {};
        const userLoggedIn = !!auth?.user;
        const isEligibleForPaidHit = profile?.data.eligibleForPaidHit;
        const userIsProCollegeClubOwnerValue = userLoggedIn && userIsProCollegeClubOwner(userLoggedIn);
        const playerAge = profile?.data?.age;
        const playerIsCollegeRecruitingAge = playerAge && playerAge >= collegeRecruitingPlayerAgeMin && playerAge <= collegeRecruitingPlayerAgeMax;
        const displayStudentInfoTabForOwnProfile = playerAge && playerAge >= collegeRecruitingPlayerAgeMin && playerAge <= collegeRecruitingOwnProfileStudentTabAgeMax;
        const displayCollegeRecruitingValues = (isOwnProfile && displayStudentInfoTabForOwnProfile) || (userIsProCollegeClubOwnerValue && playerIsCollegeRecruitingAge);
        const activeTab = _.find(tabs, { active: true });

        const playerName = profile.data?.displayName;
        const profileImage = profile.data?.profileImage;
        const profileId = profile.data?.id;
        const playerLocation = profile.data?.location?.display;
        const showStickyAd = showAds && playerProfileConfig?.showSticky;
        const showLeaderboardAd = showAds && isMobileWidth && playerProfileConfig?.showLeaderboard;

        return {
            tabs,
            isOwnProfile,
            profile,
            auth,
            search,
            showAds,
            playerProfileConfig,
            isMobileWidth,
            claimedPlayer,
            userLoggedIn,
            isEligibleForPaidHit,
            userIsProCollegeClubOwnerValue,
            playerAge,
            playerIsCollegeRecruitingAge,
            displayStudentInfoTabForOwnProfile,
            displayCollegeRecruitingValues,
            activeTab,
            playerName,
            profileImage,
            profileId,
            playerLocation,
            showStickyAd,
            showLeaderboardAd,
            statsView,
        };
    }

    /* Photo Upload */
    handleHidePhotoEditor() {
        this.setState({ showPhotoEditor: false });
        this.props.clearTempPhoto(true);
    }

    handleUploadPhotoPhotoStart() {
        this.setState({ showPhotoEditor: true, photoEditorType: 'player_profile' });
    }

    handleUploadPhotoBannerStart() {
        this.setState({ showPhotoEditor: true, photoEditorType: 'player_banner' });
    }

    handleUploadPhoto(file) {
        this.props.uploadPhoto(file);
    }

    async handleCropPhoto(values) {
        const { playerId } = this.props.auth.user.claimedPlayer;
        await this.props.cropPlayerProfilePhoto(playerId, values);
        this.setState({ showPhotoEditor: false });
        this.props.clearTempPhoto(true);
    }

    async handleCropBannerPhoto(values) {
        const { playerId } = this.props.auth.user.claimedPlayer;
        await this.props.cropPlayerBannerPhoto(playerId, values);
        this.setState({ showPhotoEditor: false });
        this.props.clearTempPhoto(true);
    }

    handlePhotoPopoverClick(item) {
        if (item.value === 'remove_banner') {
            this.props.removeBannerPhoto(this.props.profile.playerId);
        } else if (item.value === 'upload_banner') {
            this.photoInputRef.current.click();
        } else {
            // nothing to handle
        }
    }
    /* End photo upload */

    handleRemoveProfilePhoto() {
        this.props.removeProfilePhoto(this.props.profile.playerId);
    }

    handleTabClick(ev, tabIdentifier) {
        const tabToBeSelected = _.find(this.state.tabs, { id: tabIdentifier });
        const { auth } = this.props;
        const userLoggedIn = !!auth?.user;

        if (tabToBeSelected?.needsLogin && !userLoggedIn) {
            this.handleShowLoginPopUp(`tab-${tabIdentifier}`);
            return;
        }

        if (this.checkIfTabCanSwitch(tabToBeSelected)) {
            this.setState((prevState) => {
                return prevState.tabs.map((tab) => ({ ...tab, active: tabIdentifier === tab.id }));
            });

            this.props.history.push({
                search: `?t=${tabIdentifier}`,
            });
        } else if (tabToBeSelected.id === STATS) {
            this.setState((prevState) => ({ tabs: prevState.tabs }));
        } else if (tabToBeSelected.id === STUDENT_INFO) {
            this.setState((prevState) => ({ tabs: prevState.tabs }));
            this.showUpgradeToProCollege();
        } else {
            // nothing to do
        }
    }

    checkIfTabCanSwitch(tab) {
        if (tab.id !== STUDENT_INFO) {
            return true;
        }

        const { profile, auth } = this.props;
        const user = auth?.user;
        const isOwnProfile = auth?.user && profile?.data && auth.user.id === profile.data.memberId;

        return isOwnProfile || userIsProCollegeClubOwner(user);
    }

    showUpgradeToProCollege() {
        this.setState({ showUpgradeToProCollege: true });
    }

    handleProClubSuccess() {
        setTimeout(() => {
            window.location.reload();
        }, 3000);
    }

    menuSelected(optionSelected) {
        const { profile } = this.props;
        switch (optionSelected.value) {
            case 'STL':
                this.props.history.push(`/profiles/${profile.playerId}`);
                this.setState({
                    redirect: true,
                    redirectUrl: optionSelected.redirectPath,
                    redirectSearch: optionSelected.redirectSearch,
                    redirectState: {
                        firstName: profile.data.firstName,
                        lastName: profile.data.lastName,
                    },
                });
                break;
            case 'CLPH':
                this.props.removeProfilePhoto(profile.playerId);
                break;
            default:
                window.location.href = optionSelected.redirectPath;
                break;
        }
    }

    async sendMessage(recipient) {
        const { auth } = this.props;

        if (recipient?.memberId && auth?.user?.id !== recipient.memberId) {
            this.props.msgSetNewConv(true);
            this.props.msgAddRecipient(recipient);
            this.props.history.push(`/inbox`);
        }
    }

    handleShowLoginPopUp(type, screen) {
        let actionMethod;
        const userLoggedIn = !!this.props.auth?.user;
        const splitArray = type?.split('-') || [];
        switch (splitArray[0]) {
            case 'message':
                actionMethod = () => this.sendMessage(this.props?.profile?.data);
                break;
            case 'tab':
                actionMethod = () => this.handleTabClick(null, parseInt(splitArray[1]));
                break;
            case 'requestPaidHit':
                if (userLoggedIn) {
                    this.setState({ showPaidHitAvailabilityPopup: true });
                }
                break;
            case 'signin':
            case 'ratingDisplay':
            default:
                break;
        }

        const userParamsNeeded = [
            userParams.CLAIMED_PROFILE,
        ];
        if (isLoginPopUpNeeded(this.props.auth, userParamsNeeded)) {
            let popupData = {
                userParamsNeeded,
                titles: titles.PLAYER_PROFILE,
                performAction: actionMethod,
                type, // should be sent back as query while redirecting from facebook to perform proper action
            };
            if (type === 'signin' && screen) {
                popupData = { ...popupData, screen };
            }
            this.props.showLoginPopUp(popupData);
        } else if (actionMethod) {
            actionMethod();
        } else {
            // nothing to do
        }
    }

    handleOnRequestPaidHit() {
        this.handleShowLoginPopUp('requestPaidHit');
    }

    handleOnRequestClosePaidHitPopup() {
        this.setState({ showPaidHitPopupMessage: false });
    }

    handleRequestPaidHitSubmit({ values }) {
        this.showPaidHitMessage(values);
    }

    handleOnViewPaidHitsClicked() {
        const { firstName, lastName, clubMemberships } = this.props.profile?.data || {};
        const paidHitClub = clubMemberships.find(clubMembership => clubMembership.tierTypeId === ClubTierTypes.PAID_HIT);
        if (paidHitClub) {
            this.props.history.push(`/clubs/${paidHitClub.clubId}`);
        } else {
            const paidHitterName = `${firstName} ${lastName}`;
            const searchUrl = `/search?query=${encodeURIComponent(paidHitterName)}&type=events&eventTypes=paid_hit`;
            this.props.updateQueryParams(false);
            this.props.history.push(searchUrl);
        }
    }

    showEditForm() {
        this.setState((prevstate) => {
            const tabs = [...prevstate.tabs];
            const studentInfoTab = _.find(tabs, { id: PlayerProfileTabIdentifiers.STUDENT_INFO });
            studentInfoTab.showEditForm = !studentInfoTab.showEditForm;
            return ({ tabs });
        });
    }

    async showPaidHitMessage(values) {
        this.setState({
            isSendingPaidHitRequest: true,
            showPaidHitAvailabilityPopup: false,
        });
        const { profile } = this.props;
        const playerId = profile?.data?.id;
        const playerRanks = profile?.ptsRankings?.rankings;
        const maxRank = 1;
        const minRank = 100;
        const isProfessionallyRanked = playerRanks ? playerRanks.some(ranking => ranking.rank >= maxRank && ranking.rank <= minRank) : false;
        const isPaidHitter = profile?.data?.isPaidHitter;
        const playerName = profile?.data?.displayName;
        let popupMessage = '';
        let isSuccessfulRequest = false;

        try {
            const response = await requestPaidHitForPlayer(getApiAxiosInstance(), { requestedPlayerId: playerId, message: values.message });
            if (response.status === 200) {
                isSuccessfulRequest = true;
                this.setState({ isSendingPaidHitRequest: false });
            }
        } catch (e) {
            this.props.showErrorPopup({
                message: 'Error requesting Paid Hit',
                error: e,
            });
        }

        if (isSuccessfulRequest) {
            if (isProfessionallyRanked) {
                popupMessage = 'We\'ve got your request for this Pro player and will let them know that you want to do a paid hit with them!';
            } else if (isPaidHitter && !isProfessionallyRanked) {
                popupMessage = 'We\'ve sent this paid hitter your request for a paid hit!';
            } else {
                popupMessage = `Thanks for your interest in hitting with ${playerName}, we will reach out to them to encourage them to become a Paid Hitter.`;
            }
            this.setState({ paidHitPopupMessage: popupMessage, showPaidHitPopupMessage: true });
        }
    }

    calculateProfileState(nextProps) {
        const userIsFreeCollegeClubOwnerValue = userIsFreeCollegeClubOwner(nextProps.auth?.user);
        const userIsProCollegeClubOwnerValue = userIsProCollegeClubOwner(nextProps.auth?.user);
        const isOwnProfile = nextProps.auth?.user && nextProps.profile?.data && nextProps.auth.user.id === nextProps.profile.data.memberId;
        const userIsPowered = nextProps.auth?.user?.isPowered;
        const playerAge = nextProps.profile?.data?.age;
        const playerIsCollegeRecruitingAge = playerAge && playerAge >= collegeRecruitingPlayerAgeMin && playerAge <= collegeRecruitingPlayerAgeMax;
        const displayStudentInfoTabForOwnProfile = playerAge && playerAge >= collegeRecruitingPlayerAgeMin && playerAge <= collegeRecruitingOwnProfileStudentTabAgeMax;
        const profileDataIsCollegeRecruitingAge = nextProps.profile?.data?.isCollegeRecruitingAge;
        const showStudentInfoTab =
            (isOwnProfile && displayStudentInfoTabForOwnProfile) ||
            (userIsProCollegeClubOwnerValue && playerIsCollegeRecruitingAge) ||
            (userIsFreeCollegeClubOwnerValue && profileDataIsCollegeRecruitingAge);
        const rating = getRatingDetails(setRatingChoice({ player: nextProps.profile?.data }), userIsPowered, true, false, false);
        const isProgressionBallPlayer = rating.showPBRRating;
        const userLoggedIn = nextProps.auth?.user;
        const parsed = queryString.parse(this.props.location.search);
        const tabIndex = parseInt(parsed.t) || (userLoggedIn ? RESULTS : OVERVIEW);

        const isCollegeProspectEligibleAge = !!playerAge && playerAge <= collegeProspectMaxAge;

        return {
            userIsFreeCollegeClubOwnerValue,
            userIsProCollegeClubOwnerValue,
            isOwnProfile,
            userIsPowered,
            showStudentInfoTab,
            isProgressionBallPlayer,
            isCollegeProspectEligibleAge,
            tabIndex,
        };
    }

    checkIfPlayerIsSavedToList(nextProps) {
        const { playerId } = nextProps.match.params;
        return nextProps.savedLists?.playerLists?.some(list => list.players?.find(player => player.item.id == playerId)) || false;
    }

    handleResultsTabRedirect() {
        const { state } = this.props.history.location;
        if (state?.openResultsTab) {
            this.props.history.replace({
                state: null,
            });
            this.handleTabClick(null, RESULTS);
        }
    }

    handleSavedLists(nextProps, userIsPowered) {
        const shouldFetchLists = !nextProps.savedLists?.playerLists?.length &&
            !nextProps.savedLists.isLoading &&
            !nextProps.savedLists.isLoaded &&
            !nextProps.savedLists.isError &&
            userIsPowered;

        if (shouldFetchLists) {
            this.props.getSavedLists();
            return;
        }

        if (!nextProps.savedLists?.playerLists?.length) {
            return;
        }

        const playerIsSavedToList = this.checkIfPlayerIsSavedToList(nextProps);
        if (playerIsSavedToList !== this.state.isPlayerSavedToList) {
            this.setState({
                isPlayerSavedToList: playerIsSavedToList,
            });
        }
    }

    handleStudentInfoTabAccess(nextProps, profileState) {
        if (!nextProps.profile?.isProfileLoaded) {
            return;
        }

        const parsed = queryString.parse(this.props.location.search);
        const userLoggedIn = nextProps.auth?.user;
        const tabIndex = parseInt(parsed.t) || (userLoggedIn ? RESULTS : OVERVIEW);

        if (tabIndex !== STUDENT_INFO) {
            return;
        }

        const canFullyView = profileState.isOwnProfile || profileState.userIsProCollegeClubOwnerValue;
        if (canFullyView) {
            return;
        }

        if (profileState.userIsFreeCollegeClubOwnerValue) {
            this.setState({ showUpgradeToProCollege: true });
        }
        this.props.history.push(`${nextProps.location.pathname}`);
    }

    updateBanner() {
        if (this.banner) {
            const src = this.banner.currentSrc ? this.banner.currentSrc : this.banner.src;
            this.banner.parentNode.style.backgroundImage = `url("${src}")`;
        }
    }

    updateTabsVisibility(tabs, profileState) {
        const isCppEnabled = !!this.props.cppConfig?.isCollegeProspectPowerEnabled;
        const showCpp = isCppEnabled && profileState.isOwnProfile;
        return tabs.map((tab) => {
            const tabConfig = getTabVisibilityConfig(tab.id, profileState);
            const next = tabConfig
                ? { ...tab, showTab: tabConfig.showTab, needsLogin: tabConfig.needsLogin }
                : { ...tab };
            if (next.id === STUDENT_INFO) {
                next.title = showCpp ? 'College Prospect' : 'Student Info';
            }
            return next;
        });
    }

    handleProfileUpdate(nextProps, profileState) {
        const nextTabs = this.updateTabsVisibility(this.state.tabs, profileState);
        this.setState({
            tabs: nextTabs,
            isOwnProfile: profileState.isOwnProfile,
        });

        this.handleResultsTabRedirect();
        this.handleStudentInfoTabAccess(nextProps, profileState);
    }

    handlePlayerIdChange(nextProps) {
        if (this.props.profile.isLoading || nextProps.profile.isLoading) {
            return;
        }

        this.setPlayerId(nextProps.match.params.playerId);
        const hasPtsRankings = nextProps?.profile?.ptsRankings && Object.keys(nextProps?.profile?.ptsRankings).length > 0;
        if (!hasPtsRankings && !nextProps?.profile?.ptsRankingsState?.loading) {
            nextProps.getPtsPlayerRankings(nextProps.match.params.playerId);
        }
    }

    renderErrorIfNeeded() {
        const { profile } = this.props;
        const hasAttemptedLoad = !!profile.playerId && profile.playerId == this.props.match.params.playerId;
        const hasError = profile.error || (profile.isLoading === false && Object.keys(profile.data).length === 0);

        if (hasError && hasAttemptedLoad) {
            const errorConfig = getStandardErrorPageConfig({ errorData: profile.error, resourceName: 'player' });
            return (
                <ErrorPage
                    subtitle={errorConfig.subtitle}
                    showReloadButton={errorConfig.showReloadButton}
                    showBackButton={errorConfig.showBackButton}
                    data-testid="profile.error-page"
                />
            );
        }
        return null;
    }

    renderMainContent(renderData) {
        const { profile, showStickyAd, playerName, profileImage, profileId, playerLocation, claimedPlayer } = renderData;

        return (
            <div className={`${styles.playerProfile}`} data-testid="profile.container">
                {this.renderHead(playerName, profileImage, profileId, playerLocation)}
                {this.renderProfileContent(renderData)}
                {this.renderRedirect()}
                {this.renderPhotoEditor(claimedPlayer, profile)}
                {this.renderPaidHitPopups(profile)}
                {showStickyAd && <AdWrapper type={AdTypes.STICKY} data-testid="profile.ad.sticky" />}
            </div>
        );
    }

    renderHead(playerName, profileImage, profileId, playerLocation) {
        return head({
            title: playerName ? `${playerName} | Player Profile | Tennis & Pickleball` : config.defaultTitle,
            description: `Explore the UTR & UTR-P ratings, rankings, and results of ${playerLocation} player ${playerName}. Includes stats, charts, and match history for tennis & pickleball.`,
            url: `${config.appHost}/profiles/${profileId}`,
            keywords: 'Tennis players, Tennis results, UTR for players',
            image: profileImage ? `${config.cdnUrl || config.apiHost}/v1/player/${profileImage}` : `https://www.${config.siteBaseUrl}/img/utr_sports/utr-sports-logo.svg`,
            imageWidth: profileImage ? '' : '930',
            imageHeight: profileImage ? '' : '395',
        });
    }

    renderProfileContent(renderData) {
        const { profile, auth, search, isOwnProfile, activeTab, displayCollegeRecruitingValues, isEligibleForPaidHit, showLeaderboardAd, statsView } = renderData;

        if (Object.keys(profile.data).length === 0) {
            return null;
        }

        const urlPlayerId = this.props.match.params.playerId;
        if (urlPlayerId && Number(profile.data.id) !== Number(urlPlayerId)) {
            return null;
        }

        return (
            <div data-testid="profile.content">
                <ProfileHeader
                    isEligibleForPaidHit={isEligibleForPaidHit}
                    isSendingPaidHitRequest={this.state.isSendingPaidHitRequest}
                    playerId={profile.playerId}
                    profileData={profile.data}
                    handleUploadPhoto={this.handleUploadPhoto}
                    handleUploadPhotoPhotoStart={this.handleUploadPhotoPhotoStart}
                    handleRemoveProfilePhoto={this.handleRemoveProfilePhoto}
                    showRatingPopUp={this.state.showRatingPopUp}
                    popupTitle={this.state.popupTitle}
                    popupDescription={this.state.popupDescription}
                    toggleInfoPopup={this.toggleInfoPopup}
                    popUpType={this.state.popUpType}
                    menuSelected={this.menuSelected}
                    sendMessage={this.sendMessage}
                    onRequestPaidHitClicked={this.handleOnRequestPaidHit}
                    onViewPaidHitsClicked={this.handleOnViewPaidHitsClicked}
                    handleShowLoginPopUp={this.handleShowLoginPopUp}
                    auth={auth}
                    setIsProMessagePopupFlg={this.setIsProMessagePopupFlg}
                    showIsProMessagePopup={this.state.showIsProMessagePopup}
                    setUnclaimedProfileMessagePopup={this.setUnclaimedProfileMessagePopup}
                    showUnclaimedProfileMessagePopup={this.state.showUnclaimedProfileMessagePopup}
                    isPlayerSavedToList={this.state.isPlayerSavedToList}
                    data-testid="profile.header"
                />
                {showLeaderboardAd && (
                    <div className={styles.adContainer} data-testid="profile.leaderboard-ad-wrapper">
                        <AdWrapper type={AdTypes.LEADERBOARD_ONE} data-testid="profile.ad.leaderboard" />
                    </div>
                )}
                <TabBar
                    tabs={this.state.tabs}
                    handleTabClick={this.handleTabClick}
                    eventName="Profile Tab Clicked"
                    clickCategory="Player Profile"
                    clickLocation="Header Tabs"
                    data-testid="profile.tab-bar"
                />
                <div className={`${styles.content}`} data-testid="profile.tab-content-wrapper">
                    <ProfileTabManager
                        tabs={this.state.tabs}
                        activeTabIdentifier={activeTab?.id}
                        displayCollegeRecruitingValues={!!displayCollegeRecruitingValues}
                        onShowLoginPopUp={this.handleShowLoginPopUp}
                        ctaData={CtaData}
                        search={search}
                        isOwnProfile={isOwnProfile}
                        statsView={statsView}
                        onTabClick={this.handleTabClick}
                        onGetPlayerStudentInfo={this.props.getPlayerStudentInfo}
                        onSavePlayerStudentInfo={this.props.savePlayerStudentInfo}
                        onShowEditForm={this.showEditForm}
                        onShowError={this.props.showError}
                    />
                    {this.renderCollegeUpgradePopups()}
                </div>
            </div>
        );
    }

    renderCollegeUpgradePopups() {
        return (
            <>
                {this.state.showUpgradeToProCollege && (
                    <LearnMoreUtrCollegePopUp
                        data-testid="modal.profile.learn-more-college"
                        onCloseClick={() => {
                            this.setState({
                                showUpgradeToProCollege: false,
                                clubToUpgrade: null,
                            });
                        }}
                        handleUpgradeClick={(clubToUpgrade) => {
                            this.setState({
                                showUpgradeToProCollege: false,
                                showProClubPopup: true,
                                clubToUpgrade,
                            });
                        }}
                        clubOptionsToUpgrade={this.getFreeCollegeClubIdOptionsUpgrade()}
                    />
                )}
                {this.state.showProClubPopup && (
                    <UpgradeToProClubPopUp
                        data-testid="modal.profile.upgrade-pro-club"
                        skipIntro={true}
                        onCloseClick={() => this.setState({ showProClubPopup: false })}
                        onSuccess={this.handleProClubSuccess}
                        clubId={this.state.clubToUpgrade.id}
                        clubTierType={{ name: this.state.clubToUpgrade.tierTypeName }}
                        clubName={this.state.clubToUpgrade.name}
                    />
                )}
            </>
        );
    }

    renderRedirect() {
        if (!this.state.redirect) {
            return null;
        }

        return (
            <Redirect to={{
                pathname: this.state.redirectUrl,
                search: this.state.redirectSearch,
                state: this.state.redirectState,
            }}
            />
        );
    }

    renderPhotoEditor(claimedPlayer, profile) {
        if (!claimedPlayer || claimedPlayer.playerId.toString() !== profile.playerId) {
            return null;
        }

        return (
            <PhotoEditor
                showEditor={this.state.showPhotoEditor}
                closeEditor={this.handleHidePhotoEditor}
                imageUrl={this.props.uploads.tempPhotoUrl}
                uploadCropData={this.state.photoEditorType == 'player_profile' ? this.handleCropPhoto : this.handleCropBannerPhoto}
                type={this.state.photoEditorType}
                radius={this.state.photoEditorType == 'player_profile' ? 400 : 0}
                data-testid="modal.profile.photo-editor"
            />
        );
    }

    renderPaidHitPopups(profile) {
        return (
            <>
                {this.state.showPaidHitPopupMessage && (
                    <GenericPopup
                        title="Request Sent for Paid Hit"
                        subtitle={this.state.paidHitPopupMessage}
                        buttonText="Okay!"
                        onButtonClick={this.handleOnRequestClosePaidHitPopup}
                        onRequestClose={this.handleOnRequestClosePaidHitPopup}
                        data-testid="modal.profile.paid-hit-confirmation"
                    />
                )}
                {this.state.showPaidHitAvailabilityPopup && (
                    <PaidHitAvailabilityPopup
                        title="Request Paid Hit"
                        subtitle={this.state.paidHitPopupMessage}
                        paidHitAvailability={profile.data.paidHitAvailability}
                        isSendingPaidHitRequest={this.state.isSendingPaidHitRequest}
                        onSendClick={this.handleRequestPaidHitSubmit}
                        onCloseClick={() => {
                            this.setState({ showPaidHitAvailabilityPopup: false });
                        }}
                        data-testid="modal.profile.paid-hit-availability"
                    />
                )}
            </>
        );
    }

    render() {
        const renderError = this.renderErrorIfNeeded();
        if (renderError) {
            return renderError;
        }

        const renderData = this.getRenderData();
        return this.renderMainContent(renderData);
    }
}

function mapDispatchToProps(dispatch) {
    return {
        setPlayerId: (playerId) => {
            dispatch(actions.setPlayerId(playerId, true));
        },
        getPlayerStudentInfo: (playerId) => dispatch(actions.getPlayerStudentInfo(playerId)),
        savePlayerStudentInfo: (values) => dispatch(actions.updatePlayerStudentInfo(values)),
        uploadPhoto: file => dispatch(uploadTempPhoto(file)),
        clearTempPhoto: usePng => dispatch(clearTempPhoto(usePng)),
        removeProfilePhoto: playerId => dispatch(actions.removeProfilePhoto(playerId)),
        removeBannerPhoto: playerId => dispatch(actions.removeBannerPhoto(playerId)),
        cropPlayerProfilePhoto: (playerId, values) => dispatch(actions.cropPlayerProfilePhoto(playerId, values)),
        cropPlayerBannerPhoto: (playerId, values) => dispatch(actions.cropPlayerBannerPhoto(playerId, values)),
        msgAddRecipient: member => dispatch(messagingActions.addRecepient({ member })),
        closePowerPopup: () => dispatch(messagingActions.closePowerPopup()),
        msgSetNewConv: member => dispatch(messagingActions.setNewConv({ member })),
        showLoginPopUp: data => dispatch(loginPopUpActions.showLoginPopUp(data)),
        updateStatsParams: params => dispatch(actions.updateStatsParams(params)),
        getPtsPlayerRankings: playerId => dispatch(actions.getPtsPlayerRankings(playerId)),
        showError: (msg) => dispatch(showErrorPopup({ message: msg })),
        showErrorPopup: (data) => dispatch(showErrorPopup(data)),
        setClaimedPlayerId: (playerId) => dispatch(setClaimedPlayerId(playerId)),
        fetchMatchingProfilesById: (id) => dispatch(fetchMatchingProfilesById(id)),
        updateQueryParams: (shouldUpdateParams) => dispatch(updateQueryParams(shouldUpdateParams)),
        fetchUpgradePopup: prismicUid => dispatch(fetchUpgradePopup(prismicUid)),
        getSavedLists: () => dispatch(savedListActions.allSavedLists()),
        clearProfileData: () => dispatch(clearProfileTabData()),
        getPlayerStats: () => dispatch(getStatsData()),
    };
}

ProfilePage.propTypes = {
    showAds: PropTypes.bool,
    playerProfileConfig: PropTypes.shape({
        showLeaderboard: PropTypes.bool,
        showSticky: PropTypes.bool,
    }),
    isMobileWidth: PropTypes.bool,
    profile: PropTypes.shape({
        data: PropTypes.shape({
            displayName: PropTypes.string,
            profileImage: PropTypes.string,
            id: PropTypes.number,
            location: PropTypes.shape({
                display: PropTypes.string,
            }),
        }),
        playerId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
};

ProfilePage.defaultProps = {
    showAds: false,
    playerProfileConfig: PropTypes.shape({
        showLeaderboard: false,
        showSticky: false,
    }),
    isMobileWidth: false,
    profile: PropTypes.shape({
        data: PropTypes.shape({
            displayName: '',
            profileImage: '',
            id: 0,
            location: PropTypes.shape({
                display: '',
            }),
        }),
        playerId: 0,
    }),
};

function mapStateToProps({ auth, profile, uploads, search, coreUI, componentConfig, matchedProfiles, savedLists }) {
    return { auth, profile, uploads, search, coreUI, componentConfig, matchedProfiles, savedLists };
}

export default withCPPDynamicConfig(withStatsig(connect(mapStateToProps, mapDispatchToProps)(ProfilePage)));
